import React from 'react';

const styles = `
  @keyframes al-spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes al-spin-reverse {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(-360deg); }
  }

  @keyframes al-pulse {
    0%, 100% { transform: scale(1);    opacity: 1; }
    50%       { transform: scale(1.12); opacity: 0.85; }
  }

  @keyframes al-fade-in-up {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @keyframes al-shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }

  @keyframes al-dot-bounce {
    0%, 80%, 100% { transform: translateY(0);    opacity: 0.4; }
    40%            { transform: translateY(-6px); opacity: 1; }
  }

  .al-overlay {
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    gap: 32px;
  }

  .al-spinner {
    position: relative;
    width: 112px;
    height: 112px;
  }

  .al-ring-outer {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 3px solid rgba(0,0,0,0.07);
    border-top-color: #717fe0;
    border-right-color: #717fe0;
    animation: al-spin 1.6s linear infinite;
  }

  .al-ring-middle {
    position: absolute;
    inset: 12px;
    border-radius: 50%;
    border: 2.5px solid rgba(0,0,0,0.05);
    border-bottom-color: #9aaae8;
    border-left-color: #9aaae8;
    animation: al-spin-reverse 1.1s linear infinite;
    opacity: 0.75;
  }

  .al-inner {
    position: absolute;
    inset: 24px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: al-pulse 2s ease-in-out infinite;
    box-shadow: 0 0 0 2px rgba(113,127,224,0.15);
    overflow: hidden;
  }

  .al-logo {
    width: 80%;
    height: 80%;
    object-fit: contain;
  }

  .al-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    animation: al-fade-in-up 0.6s ease both;
    animation-delay: 0.2s;
    opacity: 0;
  }

  .al-company-name {
    font-family: Poppins-SemiBold, 'Poppins', sans-serif;
    font-size: 1rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    background: linear-gradient(90deg, #aaa 25%, #717fe0 50%, #aaa 75%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: al-shimmer 2.2s linear infinite;
    margin: 0;
  }

  .al-dots {
    display: flex;
    gap: 6px;
  }

  .al-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #717fe0;
    animation: al-dot-bounce 1.2s ease-in-out infinite;
  }

  .al-dot:nth-child(1) { animation-delay: 0ms; }
  .al-dot:nth-child(2) { animation-delay: 180ms; }
  .al-dot:nth-child(3) { animation-delay: 360ms; }
`;

interface AppLoaderProps {
  logoImage: string;
  companyName?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({ logoImage, companyName }) => {
  return (
    <>
      <style>{styles}</style>
      <div className="al-overlay">
        <div className="al-spinner">
          <div className="al-ring-outer" />
          <div className="al-ring-middle" />
          <div className="al-inner">
            <img
              src={logoImage}
              alt={companyName || 'Loading'}
              className="al-logo"
            />
          </div>
        </div>

        <div className="al-label">
          <p className="al-company-name">{companyName || 'Loading'}</p>
          <div className="al-dots">
            <div className="al-dot" />
            <div className="al-dot" />
            <div className="al-dot" />
          </div>
        </div>
      </div>
    </>
  );
};

export default AppLoader;